import Hero from '../sections/hero.js'
import Process from '../sections/process.js'
import Contact from "../sections/contact";
import Footer from '../includes/footer.js'

function Home() {
    return (
        <>
            <Hero />
            <Process />
            <Contact />
            <Footer />
        </>
    );
}

export default Home;